import ThemeBtn from "../Products/Common/ThemeBtn";
import DErrorResult from "./components/DErrorResult";

type Props = {
	message: string;
};
const UnexpectedError = ({ message }: Props) => {
	return (
		<>
			<DErrorResult errorMessage={message} />
			<ThemeBtn
				title='Cerrar'
				onClick={() => window.location.reload()}
				size='large'
				variant='contained'
				sx={{ mt: 18 }}
			/>
		</>
	);
};

export default UnexpectedError;
